export default __webpack_public_path__ + "static/media/gallery-wip-blade plug_00.a3993201.jpg";